import { Injectable } from '@angular/core';
import { UrlService } from '../../../../environments/urlService';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Investor } from '../dto/InvestorContribution';
import { Observable } from 'rxjs';
import { IS_SPINNER_ACTIVE } from '../../../util/interceptors';
import { IcModalCallType } from '../modals/investor-contribution-capital-call-modal/investor-contribution-capital-call-modal.component';

@Injectable({
  providedIn: 'root',
})
export class InvestorService {
  private readonly url;

  constructor(
    private urlService: UrlService,
    private http: HttpClient,
  ) {
    this.url = this.urlService.getFmsUrl() + 'fund-performance/investor';
  }

  getByFund(fundUUID: string): Observable<Investor[]> {
    return this.http.get<Investor[]>(
      this.url + '/fund',
      {
        params: { fundUUID },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true, responseType: 'json',
      });
  }

  update(investors: Investor[], fundUUID: string): Observable<void> {
    return this.http.put<void>(
      this.url, investors,
      {
        params: { fundUUID },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true, responseType: 'json',
      });
  }

  create(investors: Investor[], fundUUID: string): Observable<void> {
    return this.http.post<void>(
      this.url, investors,
      {
        params: { fundUUID },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true, responseType: 'json',
      });
  }

  deleteByFund(fundUUID: string): Observable<void> {
    return this.http.delete<void>(
      this.url + '/fund',
      {
        params: { fundUUID },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true, responseType: 'json',
      });
  }

  delete(uuid: string): Observable<void> {
    return this.http.delete<void>(
      this.url,
      {
        params: { uuid },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true, responseType: 'json',
      });
  }

  /**
   * There are 2 called types: current and prediction.
   * Sets to all investors in the fund the new 'called' value depending on the type.
   *
   * @param fundUUID is not null.
   * @param called is (between 0 and 1) or null
   * @param calledType determines which call to update.
   */
  setCurrentCalledByFund(fundUUID: string, called: number, calledType: IcModalCallType): Observable<void> {
    return this.http.put<void>(
      this.url + '/fund/called', null,
      {
        params: { fundUUID, value: called, calledType },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true, responseType: 'json',
      });
  }
}
